<!--
  银行卡
  lovi 2020-1-9
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('wallet.bankCard')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="addBank">{{ $t("common.add") }}</span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <div v-if="!bankCardList.length" class="noCard-wrap">
        <p class="text-gray">
          {{ $t("bankCard.notAddedBankCard") }}
          <span class="text-blue" @click="addBank">
            {{ $t("bankCard.clickHereAdd") }}
          </span>
        </p>
      </div>
      <scroll
        v-else
        ref="scroll"
        :data="bankCardList"
        :pullDownRefresh="true"
        @pullingDown="_getBankCardList(1)"
      >
        <div class="bank-list">
          <div
            class="item-bank"
            v-for="(item, index) in bankCardList"
            :key="index"
          >
            <div :class="`banktype${item.country}`" @click="bankCardFun(item)">
              <h3>{{ item.bank_name }}</h3>
              <h4>{{ item.card_number }}</h4>
            </div>
          </div>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  name: "bankCard",
  components: {},
  data() {
    return {
      bankCardList: []
    };
  },
  created() {
    this._getBankCardList();
  },
  mounted() {},
  computed: {},
  methods: {
    addBank() {
      this.$router.push({
        // 添加银行卡
        path: "/bindCard"
      });
    },
    bankCardFun(data) {
      // 点击银行卡
      let vm = this;
      vm.$router.push({
        path: "/bindCard",
        name: "bindCard",
        query: { bankId: data.id }
      });
    },
    _getBankCardList(flag) {
      // 获取银行卡列表
      let vm = this;
      let loading = true;
      if (flag) {
        loading = false;
      }
      vm.$post("/app/bankcard/bankCardList", {}, { loading: loading }).then(
        res => {
          console.log("bankCardList", res);
          vm.bankCardList = res.list;
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  .noCard-wrap {
    margin-top: 50px;
    text-align: center;
  }
  .bank-list {
    padding: 6px 0;
    .item-bank {
      padding: 6px 15px;
      > div {
        padding: 30px 40px;
        height: 140px;
        color: #fff;
        background-image: url("~@/assets/images/wallet/pic_card1@2x.png");
        background-repeat: no-repeat;
        background-size: 100%;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        &.banktype1 {
          background-image: url("~@/assets/images/wallet/pic_card1@2x.png");
        }
        &.banktype2 {
          background-image: url("~@/assets/images/wallet/pic_card2@2x.png");
        }
        &.banktype3 {
          background-image: url("~@/assets/images/wallet/pic_card3@2x.png");
        }
        h3,
        h4 {
          font-weight: 500;
          line-height: 1;
        }
        h3 {
          font-size: 20px;
        }
        h4 {
          margin-top: 20px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
